<template>
  <div class="item-advice"
       @click="itemClick">
    <div class="top">
      <div class="avatar">
        <img src="@/assets/images/logo-avatar-icon.svg">
      </div>
      <div class="right">
        <div class="title">
          {{ $t("feed.items.adviceItemTitle") }}
        </div>

        <div class="category">
          {{ item.details.title }}
        </div>
      </div>
    </div>
    <a :href="item.details.click_thru_url"
        class="link">
      <div class="title">
        {{ item.details.link_text }}
      </div>

      <div class="image"
           :style="imageStyles"></div>
    </a>
  </div>
</template>

<script>
  import analytics from '@/services/analytics.js'

  export default {
    props: {
      item: {
        required: true,
        type: Object
      }
    },

    methods: {
      itemClick() {
        analytics.sendEvent('Pk_Blog_Feed')
      }
    },

    computed: {
      imageStyles() {
        return {
          background: `url(${this.item.details.icon_url}) 100% 100% no-repeat`,
          'background-size': 'cover'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item-advice {
    .top {
      display: flex;
    }

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 30px;
      height: 30px;
      border-radius: 100px;
      background-color: map_get($colors, primary);

      & > img {
        width: 20px;
        height: 20px;
      }
    }

    .right {
      margin-left: 10px;

      .title {
        color: map_get($colors, primary);
      }

      .category {
        font-size: 14px;
        color: #9f9d9d;
      }
    }

    .link {
      display: block;
      font-size: 16px;
      color: #3e3a3b;
      text-decoration: none;

      .title {
        margin: 10px 0 4px 0;
      }

      .image {
        width: 100%;
        height: 170px;
        border-radius: 4px;
      }
    }
  }
</style>
